import React, { Fragment } from "react"
import { connect } from "react-redux"
import { Link } from "react-router-dom"
import { DateRangePicker } from "react-dates"
import { setLabelFilter, setTextFilter, sortByDate, sortByDateDescending, sortByAmount, setStartDate, setEndDate } from "../actions/filters"
import { startSetLabels, startAddLabel, startRemoveLabel } from "../actions/labels"
import { login } from "../actions/auth"
import { startSetAccounts } from "../actions/accounts"
import { startSetPermissions } from "../actions/permissions"
import { startSetExpenses } from "../actions/expenses"
import ConfirmLabelModal from "./ConfirmModal"
import InputLabelModal from "./InputModal"
import ConfirmAccountModal from "./ConfirmModal"
import moment from "moment"
import { subtract } from "numeral"
//import ChatPopUp from '../components/Chat/Chat/ChatPopUp'

export class ExpenseListFilters extends React.Component {
  state = {
    calendarFocused: null,
    labels: [],
    globalLabels: [],
    disableRemoveButton: true,
    removeButton: "buttonOff",
    selectedLabel: undefined,
    createLabel: false,
    accounts: [],
    accountIds: [],
    selectedAccount: undefined,
    selectedAccountId: undefined,
    openChat: false,
    chatClass: "chat-wrapper",
    chatUserId: "",
    selectedAccountEmail: "myEmail",
    allowFileUpload: false,
  }

  onInputModal = () => {
    this.setState(() => ({ createLabel: true }))
  }

  onAccountModal = (e) => {
    //console.log("onAccountModal: ", e.target.value)

    let accountId = e.target.value
    let selectAccount = this.state.accounts.filter((account) => account.id === accountId)
    this.setState(() => ({ selectedAccount: selectAccount[0].name }))
    this.setState(() => ({ selectedAccountId: selectAccount[0].id }))
    this.setState(() => ({ selectedAccountEmail: selectAccount[0].email }))
  }

  onConfirmModal = () => {
    //console.log("onConfirmModal")
    const label = this.props.filters.label
    this.setState(() => ({ selectedLabel: label }))
  }

  clearSelection = () => {
    this.setState(() => ({ selectedLabel: undefined }))
    this.setState(() => ({ createLabel: false }))
    this.setState(() => ({ selectedAccount: undefined }))
    this.setState(() => ({ selectedAccountId: undefined }))
  }

  onYTDClick = () => {
    this.props.setStartDate(moment().startOf("year"))
    this.props.setEndDate(moment().endOf("month"))
  }
  onLMTDClick = () => {
    this.props.setStartDate(moment().subtract(1, "months").startOf("month"))
    this.props.setEndDate(moment().subtract(1, "months").endOf("month"))
  }
  onLYTDClick = () => {
    this.props.setStartDate(moment().subtract(1, "years").startOf("year"))
    this.props.setEndDate(moment().subtract(1, "years").endOf("year"))
  }

  onL5YTDClick = () => {
    this.props.setStartDate(moment().subtract(5, "years").startOf("year"))
    //this.props.setEndDate(moment().subtract(1, "years").endOf("year"))
    this.props.setEndDate(moment().endOf("month"))
  }

  onMTDClick = () => {
    this.props.setStartDate(moment().startOf("month"))
    this.props.setEndDate(moment().endOf("month"))
  }
  onQTDClick = () => {
    this.props.setStartDate(moment().startOf("quarter"))
    this.props.setEndDate(moment().endOf("quarter"))
  }

  onDatesChange = ({ startDate, endDate }) => {
    this.props.setStartDate(startDate)
    this.props.setEndDate(endDate)
  }
  onFocusChange = (calendarFocused) => {
    this.setState(() => ({ calendarFocused }))
  }
  onTextChange = (e) => {
    this.props.setTextFilter(e.target.value)
  }
  onSortChange = (e) => {
    console.log("onSortChange: ", e.target.value)
    if (e.target.value === "date") {
      this.props.sortByDate()
    } else if (e.target.value === "amount") {
      this.props.sortByAmount()
    } else if (e.target.value === "dateD") {
      this.props.sortByDateDescending()
    }
  }

  onAccountChange = () => {
    let res = true
    if (res) {
      //console.log("change account")
      //console.log("authUID: ", this.props.user.authUID)
      // isUserAdmin: this.props.user.email == "jeraldmjohnson@gmail.com" || this.props.user.email == "jmjohnson@jmjc.com" ? true : false,
      const saveUID = this.props.user.authUID
      const userProfile = {
        uid: this.state.selectedAccountId,
        email: this.props.user.email,
        displayName: this.props.user.displayName,
        photoURL: this.props.user.photoURL,
        authUID: this.props.user.authUID,
        isUserAdmin: user.email == "jeraldmjohnson@gmail.com" || user.email == "jmjohnson@jmjc.com" ? true : false,
      }

      this.props.setLogin(userProfile)
      let removeButton = false
      this.setState(() => ({ removeButton }))
      this.props.setLabelFilter(undefined)
      this.clearSelection()
      this.props.startSetAccounts()
      this.props.startSetPermissions()
      this.props.startSetExpenses()
      this.props.startSetLabels().then(() => {
        let globalLabels = this.props.labels
          .map(({ label }) => label)
          .sort(function (a, b) {
            return a.toLowerCase().localeCompare(b.toLowerCase())
          })
        this.setState(() => ({ labels: globalLabels }))
        this.setState(() => ({ disableRemoveButton: true }))
      })
    } else {
      //console.log("Do Not Change account")
    }
  }

  onLabelChange = (e) => {
    let removeButton = e.target.value ? false : true
    this.setState(() => ({ removeButton }))
    this.props.setLabelFilter(e.target.value)
    this.setState(() => ({ disableRemoveButton: removeButton }))
  }

  onNewLabelModal = (childData) => {
    alert("Creating new label from modal dialog " + childData)
    this.clearSelection()
  }

  onNewLabel = (childData) => {
    let newLabel = false
    newLabel = childData
    if (!newLabel) {
      return
    }
    this.setState((prevState) => ({
      labels: [...prevState.labels, newLabel].sort(function (a, b) {
        return a.toLowerCase().localeCompare(b.toLowerCase())
      }),
    }))

    const newLabelObj = {
      label: newLabel,
      type: "",
      alias: "",
      note: "",
    }
    this.props.startAddLabel(newLabelObj)
    this.clearSelection()
  }

  onAlert = () => {
    //let email = this.props.user.displayName
    //this.props.user.displayName
    //let role = this.state.isUserAdmin
    //alert(" Is user an Admin? " + role)
    //let role = this.state.accounts[0].role
    //alert(" Is user an Admin? " + role)
    // let upload = this.state.permissions[0].allowUpload
    // console.log("Can Upload: ", upload)
    //alert(" Can user upload? " + upload)
  }

  onRemoveLabel = () => {
    let removeLabel = this.state.selectedLabel
    let labelList = this.state.labels
    let newLabelList = labelList
      .filter((label) => {
        return label !== removeLabel
      })
      .sort(function (a, b) {
        return a.toLowerCase().localeCompare(b.toLowerCase())
      })
    this.setState(() => ({ labels: newLabelList }))
    const removeLabelObj = this.props.labels.filter((label) => {
      return label.label === removeLabel
    })
    if (removeLabelObj[0].id) {
      this.props.startRemoveLabel({ id: removeLabelObj[0].id })
      this.props.setLabelFilter("")
    } else {
      alert(" Remove " + removeLabel + " failed")
    }
    this.setState(() => ({ disableRemoveButton: true }))
    this.clearSelection()
  }

  onOpenChat = () => {
    window.location.href = `/chat?name=${this.props.user.displayName}&room=Expense Users`

    // this.setState(() => ({
    //   openChat: true,
    //   chatClass: 'chat-wrapper chat--visible'
    // }))

    // console.log('openChat: ', this.state.openChat);
    // console.log('chatClass: ', this.state.chatClass);
  }

  onCloseChat = () => {
    this.setState(() => ({
      openChat: false,
      chatUserId: "",
    }))

    //console.log('closeChat: ', this.state.openChat);
  }

  onOpenPopUpChat = () => {
    //window.location.href = `/chat?name=${this.props.user.displayName}&room=Expense Users`;

    let res = prompt("Enter user id to chat:")
    if (res != undefined && res.length > 1 && res.toLowerCase() != "admin") {
      this.setState(() => ({
        openChat: true,
        chatUserId: res,
      }))
    } else {
      alert("User Id already in use")
    }
    //console.log('openChat: ', this.state.openChat);
  }
  componentDidMount() {
    let stateLabels = []
    let stateAccounts = []
    let stateAccountIds = []
    let statePermissions = []

    // set to state
    let globalLabels = this.props.labels
      .map(({ label }) => label)
      .sort(function (a, b) {
        return a.toLowerCase().localeCompare(b.toLowerCase())
      })
    stateAccounts = [...this.props.accounts].sort((a, b) => (a.name < b.name ? -1 : 1))
    stateAccountIds = this.props.accounts.map(({ id }) => id)
    this.setState(() => ({ labels: globalLabels }))
    this.setState(() => ({ accounts: stateAccounts }))
    this.setState(() => ({ disableRemoveButton: this.props.filters.label ? false : true }))
    //this.setState(() => ({ isUserAdmin: this.props.user.email == "jeraldmjohnson@gmail.com" || this.props.user.email == "jmjohnson@jmjc.com" ? true : false }))
    this.setState(() => ({ isUserAdmin: false }))
    statePermissions = [...this.props.permissions]
    this.setState(() => ({ permissions: statePermissions }))

    //isUserAdmin: user.email == "jeraldmjohnson@gmail.com" || user.email == "jmjohnson@jmjc.com" ? true : false,
    //console.log("componentDidMount() allowUploads: ", this.state.permissions[0].allowUpload)
    //this.state.allowFileUpload = this.props.permissions ? this.props.permissions[0].allowUpload : false
    //debugger
    this.state.allowFileUpload = this.props.permissions.length ? this.props.permissions[0].allowUpload : false

    //this.setState(() => ({ allowFileUpload: this.props.permissions ? this.props.permissions[0].allowUpload : false }))
    //console.log("componentDidMount() permissions: ", this.props.permissions ? this.props.permissions : "Failed")
    //this.state.accounts.length > 0 && this.state.isUserAdmin
    //this.state.accounts.length > 0 && this.state.accounts[0].role == "owner"
    //this.props.permissions[0].allowUpload
    //(this.props.user.email == "jeraldmjohnson@gmail.com" || this.props.user.email == "jmjohnson@jmjc.com")
  }

  render() {
    return (
      <div className="content-container">
        <div className="input-group">
          <div className="input-group__item">
            {this.state.allowFileUpload ? (
              <Fragment>
                &nbsp;&nbsp;
                <Link className="button" to="/upload">
                  Upload
                </Link>
              </Fragment>
            ) : (
              <div></div>
            )}
          </div>
        </div>

        <div className="input-group">
          <div className="input-group__item">
            <select id="labels" className="select" value={this.props.filters.label} onChange={this.onLabelChange}>
              <option value="">All Items</option>
              {this.state.labels.map((label) => (
                <option key={label} value={label}>
                  {label}
                </option>
              ))}
            </select>
          </div>
          <div className="input-group__item">
            <button className="button" onClick={this.onInputModal}>
              Create New Label
            </button>
            &nbsp;
          </div>
          <div className="input-group__item">
            <button className="button" disabled={this.state.disableRemoveButton ? true : false} onClick={this.onConfirmModal}>
              Remove Label
            </button>
          </div>
        </div>
        <div className="input-group">
          <div className="input-group__item">
            <input className="text-input" type="text" placeholder="Search Expenses" value={this.props.filters.text} onChange={this.onTextChange} />
          </div>
          <div className="input-group__item">
            <select className="select" value={this.props.filters.sortBy} onChange={this.onSortChange}>
              <option value="date">Date (Desc)&#8595;</option>
              <option value="dateD">Date (Asc) &#8593;</option>
              <option value="amount">Amount (Desc) &#8595;</option>
            </select>
          </div>
        </div>
        <div className="input-group">
          <div className="input-group__item">
            <DateRangePicker startDate={this.props.filters.startDate} endDate={this.props.filters.endDate} onDatesChange={this.onDatesChange} focusedInput={this.state.calendarFocused} onFocusChange={this.onFocusChange} showClearDates={true} numberOfMonths={1} isOutsideRange={() => false} />

            <div className="input-group__item">
              <button className="button-sm" title="Current Month" onClick={this.onMTDClick}>
                MTD
              </button>
              <button className="button-sm" title="Previous Month" onClick={this.onLMTDClick}>
                LMO
              </button>
              <button className="button-sm" title="Current Quarter" onClick={this.onQTDClick}>
                QTR
              </button>
              <button className="button-sm" title="Year To Date" onClick={this.onYTDClick}>
                YTD
              </button>
              <button className="button-sm" title="Last Year" onClick={this.onLYTDClick}>
                LYR
              </button>
              <button className="button-sm" title="Previous 5 Years TD" onClick={this.onL5YTDClick}>
                L5YRS
              </button>
            </div>
          </div>
        </div>
        <ConfirmAccountModal selectedTitle={this.state.selectedAccount} clearSelection={this.clearSelection} confirmAction={this.onAccountChange} message="Change Account To?" />
        <ConfirmLabelModal selectedTitle={this.state.selectedLabel} clearSelection={this.clearSelection} confirmAction={this.onRemoveLabel} message="Remove Label?" />
        <InputLabelModal createLabel={this.state.createLabel} clearSelection={this.clearSelection} confirmAction={this.onNewLabel} message="Create New Label?" />
      </div>
    )
  }
}

const mapStateToProps = (state) => ({
  filters: state.filters,
  labels: state.labels,
  accounts: state.accounts,
  user: state.auth,
  permissions: state.permissions,
})

const mapDispatchToProps = (dispatch) => ({
  setTextFilter: (text) => dispatch(setTextFilter(text)),
  setLabelFilter: (label) => dispatch(setLabelFilter(label)),
  sortByDate: () => dispatch(sortByDate()),
  sortByDateDescending: () => dispatch(sortByDateDescending()),
  sortByAmount: () => dispatch(sortByAmount()),
  setStartDate: (startDate) => dispatch(setStartDate(startDate)),
  setEndDate: (endDate) => dispatch(setEndDate(endDate)),
  startAddLabel: (labels) => dispatch(startAddLabel(labels)),
  startRemoveLabel: (labels) => dispatch(startRemoveLabel(labels)),
  setLogin: (profile) => dispatch(login(profile)),
  startSetAccounts: () => dispatch(startSetAccounts()),
  startSetPermissions: () => dispatch(startSetPermissions()),
  startSetExpenses: () => dispatch(startSetExpenses()),
  startSetLabels: () => dispatch(startSetLabels()),
})

export default connect(mapStateToProps, mapDispatchToProps)(ExpenseListFilters)



// WEBPACK FOOTER //
// ./src/components/ExpenseListFilters.js